import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { spacePrefixCls } from "@/base/components/space/Space.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Space">> = ({ testToken1 }: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${spacePrefixCls}`]: {
      color: testToken1,
    },
  },
});

export const useSpaceStyle = genComponentStyleHook(
  ["Space", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
